export default __webpack_public_path__ + "static/media/halfsemi2.99215c01.jpg";